var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_50337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25016 3.53301C8.82377 3.39874 9.41105 3.33162 10.0002 3.33301C15.8335 3.33301 19.1668 9.99967 19.1668 9.99967C18.661 10.946 18.0577 11.837 17.3668 12.658M11.7668 11.7663C11.538 12.012 11.262 12.209 10.9553 12.3456C10.6486 12.4822 10.3176 12.5557 9.9819 12.5616C9.64623 12.5676 9.3128 12.5058 9.0015 12.3801C8.69021 12.2543 8.40743 12.0672 8.17003 11.8298C7.93264 11.5924 7.74549 11.3096 7.61975 10.9983C7.49402 10.687 7.43227 10.3536 7.43819 10.0179C7.44411 9.68226 7.51759 9.35121 7.65423 9.04455C7.79087 8.73788 7.98787 8.46188 8.2335 8.23301M0.833496 0.833008L19.1668 19.1663M14.9502 14.9497C13.5257 16.0355 11.7911 16.6371 10.0002 16.6663C4.16683 16.6663 0.833496 9.99967 0.833496 9.99967C1.87007 8.06792 3.30778 6.38018 5.05016 5.04967L14.9502 14.9497Z",
    stroke: "#D1D7DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_50337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIconDisabled);
export default __webpack_public_path__ + "static/media/ShowIconDisabled.f778ead8759d64f1721b8f0c6c3e598c.svg";
export { ForwardRef as ReactComponent };